import React from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <>
      <footer className="footer pt-100">
            <div className="footer-top pb-60">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-4 col-md-6">
                            <div className="footer-widget footer-widget-1">
                                <Link to="/" className="footer-logo"><img src="assets/img/logotvplux.svg" className="logo" alt="logo" /></Link>
                                <p className="text-white mt-30">Nous offrons les meilleurs services IPTV. Notre service est simple, rapide et fiable. Vous pouvez profiter de vos chaînes préférées sur n'importe quel appareil, où que vous soyez.</p>
                            </div>
                        </div>
                        <div className="col-lg-2 col-md-3 col-sm-6">
                            <div className="footer-widget footer-widget-2 mt-2">
                                <h5 className="text-white position-relative mb-5 widget-title">Liens rapides</h5>
                                <ul className="footer-nav">
                                    <li><Link to="/refundpolicy">Politique de Remboursement</Link></li>
                                    <li><Link to="/privacypolicy">Politiques De Confidentialité</Link></li>
                                    <li><Link to="/termsandconditions">Conditions Générales d'Utilisation</Link></li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-lg-2 col-md-3 col-sm-6">
                        </div>
                        <div className="col-lg-4 col-md-8">
                            <div className="footer-widget footer-sb-widget mt-2">
                                <div className="ft-payment-method mt-40">
                                    <h5 className="text-white position-relative ft-subtitle d-inline-block">Nous acceptons</h5>
                                    <ul className="payment-list d-flex align-items-center mt-3">
                                        <li className="d-inline-flex align-items-center justify-content-center ps-1 bg-light"><img src="assets/img/paypaal.svg" alt="visa" className="img-fluid" /></li>
                                        <li className="d-inline-flex align-items-center justify-content-center bg-light"><img src="assets/img/visa 1.svg" alt="visa" className="img-fluid" /></li>
                                        <li className="d-inline-flex align-items-center justify-content-center"><img src="assets/img/mastercard.svg" alt="visa" className="img-fluid" /></li>
                                        <li className="d-inline-flex align-items-center justify-content-center bg-light"><img src="assets/img/bancontact.svg" alt="visa" className="img-fluid" /></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="footer-copyright">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-md-6">
                            <div className="copyright-txt text-white">
                                <p className="mb-0">© Tv Plux - contact@tvplux.com  </p>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="copyright-links mt-2 mt-md-0 text-start text-md-end">
                                <Link to="/refundpolicy" className="ml-20">Politique de Remboursement</Link>
                                <Link to="/privacypolicy" className="ml-20">Politiques De Confidentialité</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    </>
  );
}
